<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('shipments.health')"
    class="shipment-health-filter w-2"
    optional
  >
    <HealthMultiSelect :id="inputId" v-model="internalHealth" />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { computed, Ref, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useModelValue } from '@rygen/rygen-ui/composables';

import { ShipmentHealth, ShipmentSearchCriteria } from '@/model';

import HealthMultiSelect from '@/components/shipment/HealthMultiSelect.vue';
import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: ShipmentSearchCriteria,
    default: () => new ShipmentSearchCriteria(),
  },
});
const { id, modelValue } = toRefs(props);
const emit = defineEmits<{
  (event: 'update:model-value', newVal: ShipmentSearchCriteria): void;
}>();
const { t } = useI18n();
const { internalValue } = useModelValue(modelValue, {
  emit,
  factoryMethod: (opts: Partial<ShipmentSearchCriteria>) =>
    new ShipmentSearchCriteria(opts),
});

const internalHealth: Ref<ShipmentHealth[]> = computed({
  get() {
    return internalValue.value.healths as ShipmentHealth[];
  },
  set(newVal: ShipmentHealth[]) {
    internalValue.value.healths = newVal as string[];
  },
});
</script>
